/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyConsumptionProductionKWherM3 } from './energyConsumptionProductionKWherM3';


export interface StatusCodeValueEnergyConsumptionProductionKWherM3 { 
    value?: EnergyConsumptionProductionKWherM3;
    status_code?: number;
}

